import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "hiddenTrack", "size", "aria-label", "aria-live", "color"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import classNames from 'classnames';
import "./loadingSpinner.css";
import { IconTime } from '@lmig/lmds-react-icons';
import { useMotionPref } from './useMotionPref';
var instance = 0;
/**
 * @see [LMDS LoadingSpinner Documentation and Examples](https://designsystem.lmig.com/components/loading-spinner/code)
 *
 * API:
 *
 * @implements [LoadingSpinnerProps](https://designsystem.lmig.com/components/loading-spinner/code#loading-spinner-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var LoadingSpinner = function LoadingSpinner(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$hiddenTrack = _ref.hiddenTrack,
    hiddenTrack = _ref$hiddenTrack === void 0 ? false : _ref$hiddenTrack,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '64' : _ref$size,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Loading' : _ref$ariaLabel,
    _ref$ariaLive = _ref['aria-live'],
    ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'teal' : _ref$color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      instance++;
      return id || "lmig-Loading-Spinner-".concat(instance);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    uniqueId = _useState2[0];
  var _useMotionPref = useMotionPref(),
    motionPref = _useMotionPref.motionPref;
  var sizeNum = Number(size);
  var halfSize = sizeNum / 2;
  var strokeWidth = sizeNum === 16 ? 2 : 3;
  var radius = halfSize - strokeWidth / 2;
  var containerClasses = classNames('lmig-LoadingSpinner', "lmig-LoadingSpinner--".concat(size), "lmig-LoadingSpinner--".concat(color), className);
  var spinnerClasses = classNames('lmig-LoadingSpinner-track', "lmig-LoadingSpinner-track--".concat(color));
  return /*#__PURE__*/React.createElement(React.Fragment, null, motionPref ? /*#__PURE__*/React.createElement(IconTime, {
    size: size,
    color: color,
    title: ariaLabel,
    "aria-live": ariaLive
  }) : /*#__PURE__*/React.createElement("div", _extends({
    id: uniqueId,
    "aria-live": ariaLive,
    "aria-label": ariaLabel,
    role: "progressbar",
    className: containerClasses
  }, rest), /*#__PURE__*/React.createElement("svg", {
    className: "lmig-LoadingSpinner-spinner",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 ".concat(size, " ").concat(size),
    role: "img",
    "aria-label": "Circular progress indicator"
  }, !hiddenTrack && /*#__PURE__*/React.createElement("circle", {
    className: "lmig-LoadingSpinner-indicator",
    strokeWidth: "".concat(strokeWidth, "px"),
    cx: halfSize,
    cy: halfSize,
    r: radius
  }), /*#__PURE__*/React.createElement("circle", {
    className: spinnerClasses,
    strokeWidth: "".concat(strokeWidth, "px"),
    cx: halfSize,
    cy: halfSize,
    r: radius
  }))));
};
LoadingSpinner.propTypes = {
  /** If motion preferences are enabled, add an optional ID to this element: `<class="lmig-LoadingSpinner">`. */id: _pt.string,
  /** If motion preferences are enabled, add custom classes to this element: `<class="lmig-LoadingSpinner">`. */className: _pt.string,
  /**
     * Hides the background track in the loading spinner
     * @default false
     */
  hiddenTrack: _pt.bool,
  /**
     * Changes the size of the spinner
     * @default '64'
     */
  size: _pt.oneOf(['16', '64']),
  /**
     * @default 'Loading'
     */
  'aria-label': _pt.string,
  /**
     * @default 'polite'
     */
  'aria-live': _pt.oneOf(['off', 'polite', 'assertive']),
  /**
     * @default 'teal'
     */
  color: _pt.oneOf(['teal', 'blue'])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-loading-spinner/dist/_esm/LoadingSpinner.js
// module id = 2573
// module chunks = 0